import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { Dispatch, RootState } from "@/utils/store";
import Text from "./Text";

const Button = styled.button`
  width: 174px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 28px;
  background: ${({ theme }) => theme.colors.lightGray};
  color: ${({ theme }) => theme.colors.black};

  svg {
    margin-right: 12px;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.purple};
    color: ${({ theme }) => theme.colors.white};
    ${Text} {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

const FullScreenDisabler: FC = () => {
  const fullScreenModeEnabled = useSelector(
    (rootState: RootState) => rootState.layout.fullScreenModeEnabled
  );

  const dispatch = useDispatch<Dispatch>();

  const onClick = () => dispatch.layout.toggleFullScreenMode();

  if (!fullScreenModeEnabled) return null;

  return (
    <Button onClick={onClick}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 2.5V13.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.46967 6.53033C3.17678 6.23744 3.17678 5.76256 3.46967 5.46967C3.76256 5.17678 4.23744 5.17678 4.53033 5.46967L6.53033 7.46967C6.60224 7.54158 6.65649 7.62445 6.69309 7.71291C6.72976 7.80134 6.75 7.89831 6.75 8C6.75 8.10169 6.72976 8.19866 6.69309 8.28709C6.65649 8.37555 6.60224 8.45842 6.53033 8.53033L6.53023 8.53043L4.53033 10.5303C4.23744 10.8232 3.76256 10.8232 3.46967 10.5303C3.17678 10.2374 3.17678 9.76256 3.46967 9.46967L4.18934 8.75H1C0.585786 8.75 0.25 8.41421 0.25 8C0.25 7.58579 0.585786 7.25 1 7.25H4.18934L3.46967 6.53033Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4697 5.46967C11.7626 5.17678 12.2374 5.17678 12.5303 5.46967C12.8232 5.76256 12.8232 6.23744 12.5303 6.53033L11.8107 7.25H15C15.4142 7.25 15.75 7.58579 15.75 8C15.75 8.41421 15.4142 8.75 15 8.75H11.8107L12.5303 9.46967C12.8232 9.76256 12.8232 10.2374 12.5303 10.5303C12.2374 10.8232 11.7626 10.8232 11.4697 10.5303L9.46967 8.53033C9.39776 8.45842 9.34351 8.37555 9.30691 8.28709C9.27024 8.19866 9.25 8.10169 9.25 8C9.25 7.89831 9.27024 7.80134 9.30691 7.71291C9.34351 7.62445 9.39776 7.54158 9.46967 7.46967L11.4697 5.46967Z"
          fill="currentColor"
        />
      </svg>
      <Text as="span" $type="caption">
        Exit fullscreen
      </Text>
    </Button>
  );
};

export default FullScreenDisabler;
